module.exports = __webpack_public_path__ + "images/127_2048.jpg";